import CustomQuote from '@root/quotes/src/models/custom-quote';
import uuidv4 from '@root/vendor/uuid/v4';

export default class QuoteCustomizationService {
  static createCustomQuote(
    quotesContext,
    quoteCoveragesContext,
  ) {
    return CustomQuote.build({
      // We can just use the first quote, since we put the preferred quote at the front of the array here in the quotes context:
      //   https://github.com/Root-App/root-monorepo/blob/482c647243cb104408cf241f629a95a2fb49ad62/server/systems/entry/carrier_platform_api/app/contexts/carrier_platform_api/quotes_context.rb#L15
      ...quotesContext.quotes[0],
      quoteCoveragesContext,
    });
  }

  static updateCustomQuote(
    profileParams,
    selectedQuoteUpdates,
    updatedCoverageSymbol,
    quotingRules,
    quotesContext,
  ) {
    if (!selectedQuoteUpdates.originQuoteId) {
      selectedQuoteUpdates = selectedQuoteUpdates
        .set('originQuoteId', selectedQuoteUpdates.id)
        .set('id', uuidv4());
    }

    const profileVins = profileParams
      .getSelectedVehiclesWithVin()
      .map((v) => v.getAvailableVin());

    return selectedQuoteUpdates
      .fixupCoverages(quotingRules, updatedCoverageSymbol)
      .updatePrices(profileVins)
      .addTaxAndFees(quotesContext);
  }

  static getCoverageSelections(
    billingCycle,
    customQuote,
    profileParams,
    quotingRules,
    quoteCoveragesContext,
  ) {
    const market = profileParams.market();
    const profileVins = profileParams
      .getSelectedVehiclesWithVin()
      .map((v) => v.getAvailableVin());

    return quoteCoveragesContext.getCoverageSelections({
      billingCycle,
      customQuote,
      profileVins,
      quotingRules,
      market,
    });
  }

  static acceptCoverage(
    customQuote,
    coverageSymbol,
  ) {
    const coverage = customQuote.getCoverage(coverageSymbol);
    if (!coverage) { return customQuote; }

    const { coveredVins } = customQuote.getDeductibleInfo();
    coverage.coveredVins = coveredVins;

    return customQuote.acceptCoverages([coverage]);
  }
}
